const { CardDeck, CivilCardTypes } = require("../../Constants/Names/CardTypes");
const Card = require("./Card");

class LeaderCard extends Card {
    constructor(name, leader)
    {
        super(
            CardDeck.Civil,
            CivilCardTypes.Leader,
            null,
            name,
            leader.age,
            leader.text,
            {}
        )
        // Fixed bonuses printed along the bottom of the card, and stats it changes by a varying amount (shown as ?)
        this.bonuses = leader.bonuses ?? {};
        this.varies = leader.varies ?? [];
        // Key of the leader's portrait in the image context
        this.image = leader.image;
    }
}

module.exports = LeaderCard;